import { SCHEDULE_DATE_FORMAT as e, SCHEDULE_TIME_FORMAT as t, SCHEDULE_WEEK_STARTS_ON as n } from "./utils.js";

import { parse as a, startOfDay as r, endOfDay as i, addDays as o, addMonths as s, eachDayOfInterval as l, endOfWeek as u, startOfWeek as d, format as m, isBefore as f, differenceInMilliseconds as w, getDay as D, addMilliseconds as c, addWeeks as S } from "date-fns";

import { TZDate as y } from "@date-fns/tz";

import { object as O, number as g, string as p, array as h } from "yup";

const T = {
    weekly: "weekly",
    daily: "daily"
}, b = Object.keys(T), v = e => ({
    [T.weekly]: "Weekly",
    [T.daily]: "Does not repeat"
}[e || ""] || e), q = [ 1, 2 ], k = e => "number" == typeof e && {
    1: "Week",
    2: "Every other week"
}[e] || e, E = O({
    startDate: p().label("Start Date").required().nullable().default(null).test("minStartDate", "Start Date cannot be in the past", (function(t) {
        return !t || r(a(t, e, new Date)).valueOf() >= r(new Date).valueOf();
    })),
    endDate: p().label("End Date").required().nullable().default(null).test("minEndDate", "End Date must be later than Start Date", (function(t) {
        const {startDate: n} = this.parent || {};
        if (!t || !n) return !0;
        const r = a(n, e, new Date).valueOf();
        return a(t, e, new Date).valueOf() >= r;
    })).test("maxEndDate", "Schedule duration should not exceed 3 months", (function(t) {
        const {startDate: n} = this.parent || {};
        if (!t || !n) return !0;
        const l = r(a(n, e, new Date)).valueOf();
        return i(a(t, e, new Date)).valueOf() <= o(s(i(new Date(l)), 3), -1).valueOf();
    })),
    frequency: p().label("Repeat").oneOf(b).required().nullable().test("dailyEndDate", "Start date and end date must be the same to select does not repeat", (function(e) {
        const {startDate: t, endDate: n} = this.parent || {};
        return !n || !t || "daily" !== e || n === t;
    })),
    interval: g().label("Repeats Every").nullable().when("frequency", {
        is: e => e === T.weekly,
        then: e => e.oneOf(q).required(),
        otherwise: e => e.notRequired()
    })
}), I = O({
    startTime: p().label("Start Time").required(),
    endTime: p().label("End Time").required().test("minEndTime", "End Time must be later than Start Time", (function(e) {
        const {startTime: n} = this.parent || {};
        if (!e || !n) return !0;
        const r = a(n, t, new Date).valueOf();
        return a(e, t, new Date).valueOf() > r;
    }))
}), R = l({
    start: d(new Date, {
        weekStartsOn: n
    }),
    end: u(new Date, {
        weekStartsOn: n
    })
}).map((e => m(e, "eeeeee").toUpperCase())), M = E.concat(O({
    byweekday: h().of(p().oneOf(R)).when("frequency", {
        is: T.weekly,
        then: e => e.min(1).required(),
        otherwise: e => e.notRequired().nullable()
    }).nullable(),
    timeSegments: h().label("Time Slots").of(I).min(1).required().test("noOverlappingTimes", "Time slots should not overlap each other. Please try again.", (e => !(e => {
        const n = (e || []).filter((({startTime: e, endTime: t}) => !!e && t)).map((({startTime: e, endTime: n}) => ({
            start: a(e, t, new Date),
            end: a(n, t, new Date)
        }))).sort(((e, t) => e.start.valueOf() - t.start.valueOf()));
        for (let e = 0; e < n.length - 1; e++) if (f(n[e + 1].start, n[e].end)) return !0;
        return !1;
    })(e)))
})), U = O({
    startDate: p().required(),
    endDate: p().required()
}).required(), $ = n => {
    const {timeSegments: o, startDate: s, endDate: l, frequency: u, interval: d, byweekday: m} = n || {}, f = s ? r(a(s, e, new Date)) : new Date, w = l ? i(a(l, e, new Date)) : new Date, D = o.reduce(((e, n) => [ ...e, [ a(n.startTime, t, new Date(f)).toISOString(), a(n.endTime, t, new Date(f)).toISOString() ] ]), []);
    return {
        frequency: u || "daily",
        interval: d || 1,
        startDate: f.toISOString(),
        endDate: w.toISOString(),
        timeSegments: D,
        byweekday: m,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };
}, x = e => {
    const t = new Map;
    return e.forEach((e => {
        const {frequency: a, timeSegments: r, timezone: i, byweekday: s, interval: l, startDate: u, endDate: m} = e, f = new y(u || "", i), O = new y(m || "", i);
        if ("daily" === (a || "").toLowerCase()) return void r.forEach((([e, n]) => {
            const a = new y(e, i), r = new y(n, i), o = `${a.toISOString()}-${r.toISOString()}`;
            t.set(o, [ a.toISOString(), r.toISOString() ]);
        }));
        const g = s?.map((e => ({
            SU: 0,
            MO: 1,
            TU: 2,
            WE: 3,
            TH: 4,
            FR: 5,
            SA: 6
        }[(e || "").toUpperCase()]))) ?? [], p = d(f, {
            weekStartsOn: n
        });
        let h = p;
        r.forEach((([e, a]) => {
            const r = new y(e, i), s = new y(a, i), u = w(s, r);
            for (;h <= O; ) {
                if (h >= f && g.includes(D(h))) {
                    const e = new y(h.getFullYear(), h.getMonth(), h.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), i), n = c(e, u), a = `${e.toISOString()}-${u}`;
                    t.set(a, [ e.toISOString(), n.toISOString() ]);
                }
                h = o(h, 1), D(h) === n && (h = S(h, (l || 1) - 1));
            }
            h = p;
        }));
    })), Array.from(t.values()).sort(((e, t) => new Date(e[0]).getTime() - new Date(t[0]).getTime()));
}, z = (e, t) => {
    const n = x(e || []), a = $(t), r = x([ a ]);
    for (const [e, t] of n) for (const [n, a] of r) {
        const r = new Date(e).getTime(), i = new Date(t).getTime(), o = new Date(n).getTime(), s = new Date(a).getTime();
        if (o < i && s > r || r < s && i > o) return !0;
    }
    return !1;
};

export { T as AVAILABILITY_FREQUENCIES_MAP, b as AVAILABILITY_FREQUENCY_OPTIONS, M as CreateAvailabilityFormSchema, E as DateRangeAndRepeatFormSchema, U as ProviderScheduleSlotsFilterSchema, q as WEEKLY_INTERVAL_OPTIONS, R as WEEK_DAYS_OPTIONS, $ as createProviderScheduleBody, v as getAvailabilityFrequencyLabel, k as getWeeklyIntervalLabel, z as hasOverlappingSchedules };
//# sourceMappingURL=schemas.js.map
